/**
 * @generated SignedSource<<779b78d14cbdaf6dec5c3fdbd9acbcf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpOwners_nftItem$data = {
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "NftPdpOwners_nftItem";
};
export type NftPdpOwners_nftItem$key = {
  readonly " $data"?: NftPdpOwners_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpOwners_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpOwners_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "0a4c6cfc9652ac403238bbfbc1552c83";

export default node;
